import Block from '../landing/elements/Block'
import Col from 'react-bootstrap/Col'
import Card from '../landing/elements/Card'
import StoresList from './StoresList'
import Link from 'next/link'

export default function SectionStores ({ stores = [] }) {
  return (
    <Block>
      <Col xs={12}>
        <Card gap={5}>
          <h2
            className={'fs-4 m-0'}
          >
            Explore Local Couch Deals
          </h2>

          {stores.length === 0 && (
            <div className="d-flex flex-column gap-3 align-items-center justify-content-center">
              <div className="fs-5 text-muted">
                No stores found
              </div>
              <Link
                href={'/products'}
                className={'btn btn-success'}
              >
                Search couches in other cities
              </Link>
            </div>
          )}

          <StoresList stores={stores} />
        </Card>
      </Col>
    </Block>
  )
}
